<template>
    <div>
        <h2 class="headline-s form-headline-dealer-app">Contact Information</h2>
        <div class="field-type-dealer-app">
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputText 
                        id="email_address" v-model="email_address"
                        :class="{
                            'invalid-state-input': errors.email_address != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="email_address" :class="{'invalid-state': errors.email_address}">
                        <p>Email Address *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.email_address">{{ errors.email_address }}</p></div>
            </div>
            <div class="authorization-form input-row-dealer-app">
                <PasswordInput 
                    v-model="password" 
                    :errors="passwordTests" 
                    id="password" 
                    class="field-state-dealer-app"
                    placeholder="Password *"/>
                <PasswordInput 
                    v-model="password_confirmation" 
                    :errors="errors.password_confirmation" 
                    id="password_confirmation" 
                    placeholder="Confirm Password *"
                    class="field-state-dealer-app"
                />
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputText 
                        id="primary_contact" v-model="primary_contact"
                        :class="{
                            'invalid-state-input': errors.primary_contact != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="primary_contact" :class="{'invalid-state': errors.primary_contact}">
                        <p>Primary Contact (Full Name) *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.primary_contact">{{ errors.primary_contact }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputText 
                        id="primary_contact_title" v-model="primary_contact_title"
                        :class="{
                            'invalid-state-input': errors.primary_contact_title != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="primary_contact_title" :class="{'invalid-state': errors.primary_contact_title}">
                        <p>Primary Contact Title *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.primary_contact_title">{{ errors.primary_contact_title }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputMask
                        id="business_phone_number" v-model="business_phone_number"
                        :class="{
                            'invalid-state-input': errors.business_phone_number != null
                        }"
                        mask="(999) 999-9999"
                        placeholder=" "
                        fluid
                    />
                    <label for="business_phone_number" :class="{'invalid-state': errors.business_phone_number}">
                        <p>Business Phone Number *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.business_phone_number">{{ errors.business_phone_number }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <InputMask
                        id="mobile_phone_number" v-model="mobile_phone_number"
                        :class="{
                            'invalid-state-input': errors.mobile_phone_number != null
                        }"
                        mask="(999) 999-9999"
                        placeholder=" "
                        fluid
                    />
                    <label for="mobile_phone_number" :class="{'invalid-state': errors.mobile_phone_number}">
                        <p>Mobile Phone Number</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.mobile_phone_number">{{ errors.mobile_phone_number }}</p></div>
            </div>
        </div>
        <p class="invalid-state" v-if="errors.additional_contacts">{{ errors.additional_contacts}}</p>
        <div v-for="(contact, index) in additional_contacts" :key="index">
            <div class="form-headline-dealer-app flex-row justify-center justify-between align-center">
                <h3 class="headline-xs">Additional Contact {{ index+1 }}</h3>
                <TrashIcon class="mobile-hidden" :id="`remove_contact_${index}`" style="cursor: pointer;" @click="removeContact(index)" />
            </div>
            <div class="field-type-dealer-app">
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :id="`contact_name_${index}`" v-model="contact.name"
                            :class="{
                                'invalid-state-input': errorsContactNamesExists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`contact_name_${index}`" :class="{'invalid-state': errorsContactNamesExists(index)}">
                            <p>Contact Name *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsContactNamesExists(index)">{{ errors[`additional_contacts[${index}].name`] }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :id="`contact_title_${index}`" v-model="contact.title"
                            :class="{
                                'invalid-state-input': errorsContactTitlesExists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`contact_title_${index}`" :class="{'invalid-state': errorsContactTitlesExists(index)}">
                            <p>Contact Title *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsContactTitlesExists(index)">{{ errors[`additional_contacts[${index}].title`] }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputText 
                            :id="`contact_email_${index}`" v-model="contact.email"
                            :class="{
                                'invalid-state-input': errorsContactEmailsExists(index)
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`contact_email_${index}`" :class="{'invalid-state': errorsContactEmailsExists(index)}">
                            <p>Contact Email *</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsContactEmailsExists(index)">{{ errors[`additional_contacts[${index}].email`] }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <InputMask
                            :id="`contact_mobile_phone_number_${index}`" v-model="contact.phone"
                            :class="{
                                'invalid-state-input': errorsContactMobilePhoneNumbersExists(index)
                            }"
                            mask="(999) 999-9999"
                            placeholder=" "
                            fluid
                        />
                        <label :for="`contact_mobile_phone_number_${index}`" :class="{'invalid-state': errorsContactMobilePhoneNumbersExists(index)}">
                            <p>Mobile Phone Number</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errorsContactMobilePhoneNumbersExists(index)">{{ errors[`additional_contacts[${index}].phone`] }}</p></div>
                </div>
            </div>
            <div v-if="index == additional_contacts.length-1" class="footer-button-container">
                <RothcoCta type="button" @click="removeContact(index)" class="primary desktop-hidden-flex">Delete</RothcoCta>
                <RothcoCta class="secondary" type="button" @click="addContact">Add Additional</RothcoCta>
            </div>
            <div v-else class="footer-button-container">
                <RothcoCta type="button" @click="removeContact(index)" class="primary desktop-hidden-flex">Delete</RothcoCta>
            </div>
        </div>
        <div v-if="!additional_contacts.length" class="footer-button-container">
            <RothcoCta class="secondary" type="button" @click="addContact">Add Additional</RothcoCta>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { ref, computed, watch } from "vue";
    import RothcoCta from "./RothcoCta.vue";
    import InputText from "primevue/inputtext";
    import InputMask from "primevue/inputmask";
    import PasswordInput from "@/components/PasswordInput.vue";
    import TrashIcon from "@icons/trash-icon.svg";
    let email_address = defineModel("email_address", {type: String, default: ''});
    let password = defineModel("password", {type: String, default: ''});
    let password_confirmation = defineModel("password_confirmation", {type: String, default: ''});
    let primary_contact = defineModel("primary_contact", {type: String, default: ''});
    let primary_contact_title = defineModel("primary_contact_title", {type: String, default: ''});
    let business_phone_number = defineModel("business_phone_number", {type: String, default: ''});
    let mobile_phone_number = defineModel("mobile_phone_number", {type: String, default: ''});
    let additional_contacts = defineModel("additional_contacts", {type: Array<Object>, default: []});
    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {};
        }
    });
    let passwordTests = computed(()=>{
       let passwordErrors = Object.keys(errors.value).filter((key) => {
           return key === 'password';
       }).map((key) => {
           return errors.value[key];
       });
       return passwordErrors
    })

    function errorsContactNamesExists(index){
        return errors.value[`additional_contacts[${index}].name`];
    }
    function errorsContactTitlesExists(index){
        return errors.value[`additional_contacts[${index}].title`];
    }
    function errorsContactEmailsExists(index){
        return errors.value[`additional_contacts[${index}].email`];
    }
    function errorsContactMobilePhoneNumbersExists(index){
        return errors.value[`additional_contacts[${index}].phone`];
    }
    function addContact(){
        additional_contacts.value = [...additional_contacts.value, {
            name: '',
            title: '',
            email: '',
            phone: '',
        }];
    }
    function removeContact(index) {
        let contacts = JSON.parse(JSON.stringify(additional_contacts.value));
        contacts.splice(index, 1);
        additional_contacts.value = contacts;
    }
    let hasTypedInField = ref(new Map())
    watch(() =>password, (value) => {
        if(value.length > 0) {
            hasTypedInField.value.set('password', true);
        }
    })
</script>
<style scoped lang="scss">
.footer-button-container {
    display: flex; 
    justify-content: center; 
    padding: 1.25rem; 
    gap: 1.25rem;
}
</style>